require('./kovSimpleHeader.scss');

class SimpleHeader {

  constructor($scope){
    'ngInject';
    this.$scope = $scope;
  }

  onLogoClick() {
    this.$scope.$emit('onLogoClicked');
  }
}


module.exports = {
  template: require('./kovSimpleHeader.html'),
  controllerAs: 'ctrl',
  controller: SimpleHeader
};
